import Vue from 'vue';
import { SentryService } from '@amarkets/atlas/esm/lib/sentry';

export default function createSentry({ config }) {
  return new SentryService({
    Vue,
    ...config,
  });
}
